import { centsToUsdString } from '@paperstac/helpers/lib/numberHelpers';
import getPath from '@paperstac/routes/lib/getPath';
import { TRANSACTIONS_SINGLE } from '@paperstac/routes/lib/webRoutes';
import Box from '@paperstac/ui/lib/Box';
import Drawer from '@paperstac/ui/lib/Drawer';
import DrawerHeader from '@paperstac/ui/lib/DrawerHeader';
import Flex from '@paperstac/ui/lib/Flex';
import ChecklistIcon from '@paperstac/ui/lib/icons/ChecklistIcon';
import ChevronRightIcon from '@paperstac/ui/lib/icons/ChevronRightIcon';
import NewIcon from '@paperstac/ui/lib/icons/NewIcon';
import Image from '@paperstac/ui/lib/Image';
import Link from '@paperstac/ui/lib/Link';
import Overlay from '@paperstac/ui/lib/Overlay';
import Pill from '@paperstac/ui/lib/Pill';
import React from 'react';
import AccountAcceptancePill from '../../common/AccountAcceptancePill';
import { MyListingsPageContext } from './MyListingsPageProvider';

const ViewTransactionsOverlay = React.memo(() => {
  const { resetTransactionsToView, transactionsToView } = React.useContext(MyListingsPageContext);

  return (
    <Overlay onClose={resetTransactionsToView}>
      <Drawer width={360}>
        <DrawerHeader text="Transactions From Listing" onClose={resetTransactionsToView} />
        <Box sx={{ overflowY: 'auto', flex: '1 1 auto' }}>
          {transactionsToView.map((transaction) => (
            <Box
              key={transaction.id}
              sx={{
                m: 2,
                p: 3,
                border: 'default',
                borderRadius: 'corner',
                bg: 'white',
              }}
            >
              <Flex alignItems="center" mb={2}>
                <Image
                  src={transaction.buyer.avatar}
                  width={24}
                  height={24}
                  sx={{ borderRadius: 'circle', mr: 2, bg: 'white' }}
                  alt={`${transaction.buyer.displayName}'s profile pic`}
                />
                <Box>{transaction.buyer.displayName}</Box>
              </Flex>

              <Flex alignItems="center" mb={2}>
                <Box
                  sx={{
                    fontSize: 3,
                    fontWeight: 'bold',
                    mr: 3,
                    lineHeight: 1,
                  }}
                >
                  {centsToUsdString(transaction.price)}
                </Box>
                <AccountAcceptancePill
                  accepts={transaction.sellerAcceptsPricing}
                  avatar={transaction.seller.avatar}
                  displayName={transaction.seller.displayName}
                  mr={2}
                />
                <AccountAcceptancePill
                  accepts={transaction.buyerAcceptsPricing}
                  avatar={transaction.buyer.avatar}
                  displayName={transaction.buyer.displayName}
                />
              </Flex>
              <Flex alignItems="center" width="100%" mb={3}>
                <Box flex="0 0 auto" color="darkBlue" fontSize={1} fontWeight="bold" mr={2}>
                  Progress
                </Box>
                <Box
                  sx={{
                    flex: '1 1 0',
                    position: 'relative',
                    borderRadius: 'corner',
                    overflow: 'hidden',
                    mr: 2,
                  }}
                >
                  <Box
                    sx={{
                      bg: 'darkBlue',
                      height: '10px',
                      width: `${transaction.completionPercent}%`,
                      position: 'absolute',
                      top: 0,
                      left: 0,
                    }}
                  />
                  <Box sx={{ bg: 'darkBlue', height: '10px', opacity: 0.3 }} />
                </Box>
                <Box flex="0 0 auto" color="darkBlue" fontSize={1} fontWeight="bold">
                  {transaction.completionPercent}%
                </Box>
              </Flex>

              <Flex alignItems="center">
                {!!transaction.sellerTodos && !!transaction.sellerTodos.length && (
                  <Pill
                    bg={transaction.sellerTodos.length ? 'primary' : 'gray.6'}
                    height={24}
                    lineHeight={'24px'}
                    py={0}
                    mr={2}
                  >
                    {transaction.sellerTodos.length} <ChecklistIcon sx={{ position: 'relative', top: '-1px' }} />
                  </Pill>
                )}
                {!!transaction.sellerUnviewedEvents && !!Object.keys(transaction.sellerUnviewedEvents).length && (
                  <Pill bg="green" height={24} lineHeight={'24px'} py={0} mr={2}>
                    {Object.keys(transaction.sellerUnviewedEvents).length}{' '}
                    <NewIcon
                      sx={{
                        position: 'relative',
                        top: '-1px',
                      }}
                    />
                  </Pill>
                )}
                <Box flexGrow={1} textAlign="right">
                  <Link to={getPath(TRANSACTIONS_SINGLE, transaction.id)}>
                    View Transaction
                    <ChevronRightIcon size={12} sx={{ position: 'relative', top: '-1px', ml: '2px' }} />
                  </Link>
                </Box>
              </Flex>
            </Box>
          ))}
        </Box>
      </Drawer>
    </Overlay>
  );
});

ViewTransactionsOverlay.propTypes = {};

ViewTransactionsOverlay.defaultProps = {};

ViewTransactionsOverlay.displayName = 'ViewTransactionsOverlay';

export default ViewTransactionsOverlay;
